import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

/**
 * SectionHeader - Navigation header for WorkoutTracker sections
 * Shows current section, back button, and quick navigation to other sections
 */
function SectionHeader({
  currentSection,
  onBack,
  onNavigate,
  showQuickNav = true
}) {
  const sections = [
    { id: 'exercises', label: 'Exercises', icon: 'fa-list', variant: 'info' },
    { id: 'templates', label: 'Templates', icon: 'fa-file-alt', variant: 'primary' },
    { id: 'programs', label: 'Programs', icon: 'fa-calendar-week', variant: 'purple' },
    { id: 'logger', label: 'Logger', icon: 'fa-play-circle', variant: 'success' },
    { id: 'history', label: 'History', icon: 'fa-history', variant: 'warning' },
    { id: 'analytics', label: 'Analytics', icon: 'fa-chart-bar', variant: 'info' }
  ];

  const currentSectionData = sections.find(s => s.id === currentSection);

  return (
    <div className="workout-section-header mb-3">
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
        {/* Left side: Back button and current section */}
        <div className="d-flex align-items-center gap-2">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={onBack}
            title="Back to Home"
          >
            <i className="fas fa-arrow-left"></i>
          </Button>
          <h4 className="mb-0 d-flex align-items-center">
            <i className={`fas ${currentSectionData?.icon} me-2`}></i>
            {currentSectionData?.label}
          </h4>
        </div>

        {/* Right side: Quick navigation */}
        {showQuickNav && onNavigate && (
          <div className="d-none d-md-block">
            <ButtonGroup size="sm">
              {sections
                .filter(s => s.id !== currentSection)
                .map(section => (
                  <Button
                    key={section.id}
                    variant={`outline-${section.variant === 'purple' ? 'secondary' : section.variant}`}
                    onClick={() => onNavigate(section.id)}
                    title={`Go to ${section.label}`}
                    style={section.variant === 'purple' ? {
                      borderColor: '#9b59b6',
                      color: '#9b59b6'
                    } : {}}
                  >
                    <i className={`fas ${section.icon} me-1`}></i>
                    {section.label}
                  </Button>
                ))}
            </ButtonGroup>
          </div>
        )}
      </div>
    </div>
  );
}

export default SectionHeader;
